import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import Panel from 'components/atoms/GefMui/Panel';
import PAGES from 'constants/pages';
import { resetDashboardRelatedPages } from 'features/views/dashboard/actions';

import MainWidgets from './DashboardSellerPpz/MainWidgets';

export const DashboardSellerPpz = () => {
	const dispatch = useDispatch();

	useEffect(() => {
		// reset related complex pages, which you can redirect to via dashboard
		dispatch(resetDashboardRelatedPages());
	}, [dispatch]);

	return (
		<Panel className="DashboardPage" screenName={PAGES.dashboard.name} screenId={PAGES.dashboard.id} spacing={0}>
			<MainWidgets />
		</Panel>
	);
};

export default DashboardSellerPpz;
